export enum AppPaths {
    Root = '/',
    Events = '/events',
    SettingsAdmins = '/admins',
    SettingsConfig = '/config',
}
